import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { LanguageProvider } from '@/contexts/LanguageContext';
import { CartProvider } from '@/contexts/CartContext';
import { InventoryProvider } from '@/contexts/InventoryContext';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloat from '@/components/WhatsAppFloat';
import CartDrawer from '@/components/CartDrawer';
import ScrollToTop from '@/components/ScrollToTop';
import Home from '@/pages/Home';
import Products from '@/pages/Products';
import ProductDetail from '@/pages/ProductDetail';
import About from '@/pages/About';
import Distributors from '@/pages/Distributors';
import Contact from '@/pages/Contact';
import Registration from '@/pages/Registration';
import RaffleLive from '@/pages/RaffleLive';
import Admin from '@/pages/Admin';
import Team from '@/pages/Team';
import PrivacyPolicy from '@/pages/PrivacyPolicy';

const Shell = ({ children }) => {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith('/admin') || loc.pathname.startsWith('/equipo');
  return (
    <>
      {!isAdmin && <Navbar />}
      {children}
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppFloat />}
      {!isAdmin && <CartDrawer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <InventoryProvider>
          <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Shell>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/productos" element={<Products />} />
                <Route path="/productos/:slug" element={<ProductDetail />} />
                <Route path="/sobre" element={<About />} />
                <Route path="/distribuidores" element={<Distributors />} />
                <Route path="/contacto" element={<Contact />} />
                <Route path="/registro" element={<Registration />} />
                <Route path="/sorteo" element={<RaffleLive />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/equipo" element={<Team />} />
                <Route path="/privacidad" element={<PrivacyPolicy />} />
                <Route path="*" element={<Home />} />
              </Routes>
            </Shell>
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </CartProvider>
        </InventoryProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
